// extracted by mini-css-extract-plugin
export var label = "TextInput-module--label--23435";
export var wrapper = "TextInput-module--wrapper--14bd3";